import API from '@core/api.js'
import { useHttp } from '@core/composables/useHttp'
import { getUserData } from '@core/auth/utils'
import { decamelizeKeys } from 'humps'

import { clearState as clearGeneralState } from '@modules/app-steps/step-two/index.state'
import { clearState as clearPackagesTabState } from '@modules/app-steps/step-two/tabs/packages/state'
import { clearState as clearUploadTabState } from '@modules/app-steps/step-two/tabs/upload/state'
import { clearState as clearImagesTabState } from '@modules/app-steps/step-two/tabs/images/state'
import { clearState as clearWritingTabState } from '@modules/app-steps/step-two/tabs/writing/state'
import { clearState as clearPrepayTabState } from '@modules/app-steps/step-two/tabs/prepay/state'
import { useOrderStore } from '@/stores/order'
import { useTabsStore } from '@/stores/tabs'
import { useRoute } from 'vue-router'

import {
  IS_MAIN_STORAGE_KEY,
  SPECIAL_PACKAGE_STORAGE_KEY,
} from '@modules/app-steps/step-one/useSpecialPackage'
import { REDEEMED_WRITING_CREDIT } from '@core/constants'

const clearTabsState = () => {
  clearGeneralState()
  clearPackagesTabState()
  clearUploadTabState()
  clearImagesTabState()
  clearWritingTabState()
  clearPrepayTabState()
}

const startOrder = () => {
  const orderStore = useOrderStore()
  const tabsStore = useTabsStore()

  const route = useRoute()

  const { firstName, lastName, phone } = getUserData()

  const { data, isLoading, execute } = useHttp({
    method: 'POST',
  })

  const executeStartOrder = (payload = { firstName, lastName, phone }) => {
    localStorage.removeItem(REDEEMED_WRITING_CREDIT)

    if (route.name !== 'special-package') {
      localStorage.removeItem(IS_MAIN_STORAGE_KEY)
      localStorage.removeItem(SPECIAL_PACKAGE_STORAGE_KEY)
    }

    return new Promise((resolve) => {
      clearTabsState()
      orderStore.clearOrder()
      // tabsStore.backTabsToInitialState()

      execute(
        { url: API.startOrderResource, payload: decamelizeKeys(payload) },
        () => resolve(data)
      )
    })
  }

  return { executeStartOrder, isLoading }
}

export { clearTabsState, startOrder }
